import { UpdateEmailSignatureInput } from "shared";
import { axiosClient } from "utilz";
import { apiErrorHandler } from "utilz/helpers";

export const getCompanySignature = async () => {
  try {
    const url = "v1/company/signature";
    const response = await axiosClient.get(`${url}`);
    const resData = response?.data;
    if (resData?.success === true && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const getIndividualSignature = async () => {
  try {
    const url = "v1/individual/signature";
    const response = await axiosClient.get(`${url}`);
    const resData = response?.data;
    if (resData?.success === true && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const UpdateCompanySignature = async (
  data: UpdateEmailSignatureInput
) => {
  try {
    const url = "v1/company/signature";
    const response = await axiosClient.patch(`${url}`, data);
    const resData = response?.data;
    if (
      resData?.success === true &&
      (resData?.statusCode === 200 || resData?.statusCode === 201)
    ) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const UpdateIndividualSignature = async (
  data: UpdateEmailSignatureInput
) => {
  try {
    const url = "v1/individual/signature";
    const response = await axiosClient.patch(`${url}`, data);
    const resData = response?.data;
    if (
      resData?.success === true &&
      (resData?.statusCode === 200 || resData?.statusCode === 201)
    ) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const getPersonalSignature = async () => {
  try {
    const url = "v1/personal/signature";
    const response = await axiosClient.get(`${url}`);
    const resData = response?.data;
    if (resData?.success === true && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const UpdatePersonalSignature = async (
  data: UpdateEmailSignatureInput
) => {
  try {
    const url = "v1/personal/signature";
    const response = await axiosClient.patch(`${url}`, data);
    const resData = response?.data;
    if (
      resData?.success === true &&
      (resData?.statusCode === 200 || resData?.statusCode === 201)
    ) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};
